export const docTableHeadList = [{
  id: 'fileName',
  label: 'File Name'
}, {
  id: 'dateAdded',
  label: 'Date Added'
}];
//# sourceMappingURL=docTableHeadList.js.map